/**
 * サイト設定 (サイト名・外部リンク・コピーライト) を起動時に 1 回取得して配る。
 * Provider が無い場所 (Storybook など) では既定値がそのまま使われる。
 */
import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';
import { fetchSite } from '../api/client';
import { SITE_DEFAULTS, type SiteInfo } from '../data/siteDefaults';

const SiteContext = createContext<SiteInfo>(SITE_DEFAULTS);

export function SiteProvider({ children, value }: { children: ReactNode; value?: SiteInfo }) {
  const [site, setSite] = useState<SiteInfo>(value ?? SITE_DEFAULTS);

  useEffect(() => {
    if (value) return;
    const controller = new AbortController();
    fetchSite(controller.signal)
      .then((s) =>
        setSite({ ...SITE_DEFAULTS, ...s, links: { ...SITE_DEFAULTS.links, ...s.links } }),
      )
      .catch(() => {
        /* 取得できなくても既定値で表示を続ける */
      });
    return () => controller.abort();
  }, [value]);

  return <SiteContext.Provider value={value ?? site}>{children}</SiteContext.Provider>;
}

export function useSite(): SiteInfo {
  return useContext(SiteContext);
}
